<template>
  <div :class="$vuetify.breakpoint.smAndDown ? 'base-form' : 'base-form pa-4'" class="pb-4">
    <v-form @submit.prevent="showConfirm=true">
      <v-card class="mb-5">
        <v-card-title>
          <v-btn icon @click="goBack(); $emit('goBack')" type="button" id="volver">
            <v-icon>arrow_back</v-icon></v-btn>
          <h3>{{formTitle}}</h3>
          <v-spacer></v-spacer>
          <v-btn text color="primary" :disabled="borrando || guardando || cargandoRegistro" id="eliminar_registro"
                 v-if="id && puedeEliminar" @click="mostrarConfirmacionBorrar=true">Eliminar</v-btn>
          <v-btn text color="primary"
                 @click="showAdmitirDialog = true"
                 v-if="puedeAdmitir">Admitir formulario</v-btn>
        </v-card-title>
        <v-card-text>
          <slot name="form"
                :baseUrl="baseUrl"
                :id="id"
                :camposIgnorados="camposIgnorados"
                :erroresValidacion="erroresValidacion"
                :guardando="guardando"
                :borrando="borrando"
                :cargandoRegistro="cargandoRegistro"
                :formModel="formModel"
                :readOnly="readOnly"
                :headers="headers"
                :fieldWithHintText="fieldWithHintText"
                :selectActions="selectActions"
          >
            <FormularioGenericForm
                ref="remoteGenericForm"
                :base-url="baseUrl"
                :id="id"
                :campos-ignorados="camposIgnoradosComputed"
                :errores-validacion="erroresValidacion"
                :disabled="guardando || borrando || cargandoRegistro"
                v-model="formModel"
                :readonly="readOnly"
                @registroLoaded="onGetRegistroDto($event)"
                @cargandoRegistroChange="cargandoRegistro = $event"
                @dtoLoaded="onDtoLoaded($event)"
                :headers="headers"
                :field-with-hint-text="fieldWithHintText"
                :select-actions="selectActions"
                @appendEvent="appendEvent($event)"
            >
            </FormularioGenericForm>
          </slot>
        </v-card-text>
      </v-card>
      <v-btn
          fixed
          dark
          fab
          bottom right
          type="submit"
          title="Guardar"
          color="secondary"
          :loading="guardando || cargandoRegistro || borrando"
          id="guardar_registro"
          v-if="puedeEditar"
      >
        <v-icon>send</v-icon>
      </v-btn>
    </v-form>
    <InfoSnackbar :snackbar="snackbar" id="snackbar"/>
    <v-snackbar
        bottom left
        v-model="descargando"
    ><v-progress-circular v-model="porcentajeDescarga" :indeterminate="totalDescarga === null"></v-progress-circular>Descargando documento</v-snackbar>
    <DeleteDialog
        :id="id"
        v-if="mostrarConfirmacionBorrar"
        :base-url="baseUrl"
        @close="goBack()"
        @cancel="mostrarConfirmacionBorrar = false"
    />
    <AdmitirFormularioForm v-if="showAdmitirDialog"
                           @saved="onFormularioAdmitido()"
                           @close="showAdmitirDialog = false"
                           base-url="formularios/admitir"
    ></AdmitirFormularioForm>
    <v-dialog
        :max-width="$vuetify.breakpoint.mobile ? '360px' : '480px'"
        v-model="showConfirm"
    >
      <v-card>
        <v-card-title>{{confirmTitle}}</v-card-title>
        <v-card-text>{{confirmText}}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="showConfirm=false">Cancelar</v-btn>
          <v-btn text color="primary" @click="guardarForm();showConfirm=false">{{confirmBtnText}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import FormBase from '@/components/FormBase';
import FormularioGenericForm from '@/views/formularios/FormularioGenericForm';
import { mapActions, mapState } from 'vuex';
import { ESTADO_BORRADOR, ROL_DINACOPA_ADMISION } from '@/constants';
import FormDialog from '@/components/FormDialog';
import AdmitirFormularioForm from '@/views/dinacopa/AdmitirFormularioForm';
import { importadorHeaders } from '@/views/configuracion/importadores/ListaImportadores';

export default {
  name: 'FormularioForm',
  components: { AdmitirFormularioForm, FormDialog, FormBase, FormularioGenericForm },
  extends: FormBase,
  computed: {
    headers () {
      return [
        {
          idImportador: importadorHeaders,
          idPersona: [
            {text: 'Nro. Documento', value: 'nroDocumento'},
            {text: 'Nombre', value: 'nombre'},
            {text: 'Apellido', value: 'apellido'},
          ],
        },
      ];
    },
    ...mapState('auth', ['usuario']),
      createUrl() {
        return `${process.env.VUE_APP_ROOT_API}${this.baseUrl}`;
      },
      updateUrl() {
        return `${process.env.VUE_APP_ROOT_API}${this.baseUrl}/${this.id}`;
      },
    puedeAdmitir() {
      return this.usuario && this.usuario.usuario && this.usuario.usuario.rol.nombre === ROL_DINACOPA_ADMISION
          && this.formModel && this.formModel.idEstado === ESTADO_BORRADOR;
    },
    puedeEliminar() {
      return this.usuario && this.usuario.exportador
          && this.formModel && this.formModel.idEstado === ESTADO_BORRADOR;
    },
    readOnly() {
      return !!this.id;
    },
    ...mapState('formularios', ['formularioForm']),
    formTitle() {
      return (!this.id ? 'Generar formulario' :
          `Formulario #${this.id}`);
    },
    camposIgnoradosComputed() {
      return this.id ? [] : null;
    },
  },
  data: () =>({
    showAdmitirDialog: false,
  }),
  methods: {
    onFormSaved(resultObj) {
      this.limpiarFormulario();
      this.$emit('saved', resultObj);
      this.$router.push(`/formulario`);
    },
    ...mapActions('formularios', ['guardarFormulario', 'limpiarFormulario', ]),
    onFormularioAdmitido() {
      this.showAdmitirDialog = false;
      this.getRegistro();
      this.getHistorico(this.id);
    },
    getFormModel() {
      let model = Object.assign({}, this.formModel);
      let data = new FormData();
      data.append('dto', JSON.stringify(model));
      if (this.formModel['facturas']) {
        for (let factura of this.formModel['facturas']) {
          data.append('facturas',
              new File([factura.factura], encodeURIComponent(factura.factura.name), {
                type: factura.factura.type,
                lastModified: factura.factura.lastModified,
              })
          );
        }
      }
      return data;
    },
    ...mapActions('estados', ['getHistorico', ]),
  },
  beforeMount() {
    this.formModel = this.formularioForm;
  },
  watch: {
    formModel() {
      if (this.usuario.exportador) {
        this.$nextTick(
            () => {
              this.formModel.razonSocialExportador = this.usuario.exportador.razonSocial;
              this.formModel.rucExportador = this.usuario.exportador.ruc;
              this.formModel.direccionExpo = this.usuario.exportador.direccion;
              this.formModel.ciudadExportador = this.usuario.exportador.ciudad;
              if(this.usuario.exportador.codigoPostal){
               this.formModel.codigoPostal= this.usuario.exportador.codigoPostal; 
                }
              if(this.usuario.exportador.personaContacto){
               this.formModel.personaContacto= this.usuario.exportador.personaContacto;
              }
              if(this.usuario.exportador.telefono){
                this.formModel.telefono= this.usuario.exportador.telefono;
               }
              if(this.usuario.exportador.email){
                  this.formModel.emailExpo= this.usuario.exportador.email;
              }
            
              this.guardarFormulario(this.formModel);
            }
        );
      }
    }
  },
};
</script>

<style scoped>

</style>
